<div [class.loader-hidden]="!show" class="loader-overlay">
	<p-progressBar mode="indeterminate" [style]="{'height': '6px'}" *ngIf="show"></p-progressBar>
</div>
